import { createFileRoute } from '@tanstack/react-router'

import { MerchantRiskScreen } from './-components/merchant-risk-screen.tsx'

export const Route = createFileRoute('/risk/merchant-risk')({
  component: MerchantRiskScreen
})
